export default __webpack_public_path__ + "static/media/property_856.65a153f9.png";